//frontend/dispatcher-client/src/hooks/usePersonnelPermissions.js
import {
  getStoredUser,
} from "../lib/authStorage";

import {
  usePermissionsSettingsData,
} from "./usePermissionsSettingsData";

export const PERSONNEL_VIEW_ROUTES = [
  {
    permission:
      "personnelCalendarView",

    path:
      "/personnel/dashboard",
  },

  {
    permission:
      "personnelCalendarView",

    path:
      "/personnel/calendar",
  },

  {
    permission:
      "personnelRequestsView",

    path:
      "/personnel/requests",
  },

  {
    permission:
      "personnelPublicHolidaysView",

    path:
      "/personnel/public-holidays",
  },

  {
    permission:
      "personnelCompensationView",

    path:
      "/personnel/compensation",
  },
];

export default function usePersonnelPermissions() {
  const {
    matrix,
    loading,
  } =
    usePermissionsSettingsData();

  const user =
    getStoredUser();

  const role =
    String(
      user?.role ||
        user?.Role ||
        ""
    )
      .trim()
      .toLowerCase();

  const isAdmin =
    role ===
    "admin";

  const rolePermissions =
    matrix?.[
      role
    ] ||
    {};

  const can =
    (
      permission
    ) =>
      rolePermissions?.[
        permission
      ] ===
      true;

  const allowedViewRoutes =
    PERSONNEL_VIEW_ROUTES.filter(
      (
        item
      ) =>
        can(
          item.permission
        )
    );

  const firstAllowedPath =
    allowedViewRoutes[
      0
    ]?.path ||
    "/dashboard";

  const hasAnyView =
    allowedViewRoutes.length >
    0;

  return {
    role,

    isAdmin,

    permissionsLoading:
      loading,

    can,

    hasAnyView,

    firstAllowedPath,

    allowedViewRoutes,

    dashboardView:
      can(
        "personnelCalendarView"
      ),

    calendarView:
      can(
        "personnelCalendarView"
      ),

    requestsView:
      can(
        "personnelRequestsView"
      ),

    requestsCreate:
      can(
        "personnelRequestsCreate"
      ),

    requestsEdit:
      can(
        "personnelRequestsEdit"
      ),

    requestsApprove:
      can(
        "personnelRequestsApprove"
      ),

    requestsCancel:
      can(
        "personnelRequestsCancel"
      ),

    requestsDelete:
      can(
        "personnelRequestsDelete"
      ),

    publicHolidaysView:
      can(
        "personnelPublicHolidaysView"
      ),

    publicHolidaysCreate:
      can(
        "personnelPublicHolidaysCreate"
      ),

    publicHolidaysEdit:
      can(
        "personnelPublicHolidaysEdit"
      ),

    publicHolidaysDelete:
      can(
        "personnelPublicHolidaysDelete"
      ),

    compensationView:
      can(
        "personnelCompensationView"
      ),

    compensationCreate:
      can(
        "personnelCompensationCreate"
      ),

    compensationEdit:
      can(
        "personnelCompensationEdit"
      ),

    compensationConfirm:
      can(
        "personnelCompensationConfirm"
      ),

    compensationDelete:
      can(
        "personnelCompensationDelete"
      ),

    workDaysManage:
      can(
        "personnelWorkDaysManage"
      ),
  };
}